import React from 'react'
import ProgressBarMultiDoc from "./ProgressBarMultiDoc";
import { List, Map,fromJS } from 'immutable'

import {
    t,
	} from '../../helpers/global'

function renderStatus(status,translation=null){
    if (translation) {
        switch (status) {
            case 'paused':
                
                return t(translation,'LABEL_PAUSED_LANDING_PAGE');
            case 'failed':
                return t(translation,'LABEL_FAILED_LANDING_PAGE');
            case 'finish':
                return 'Success';
            case 'unsupported':
                    return t(translation,'LABEL_FAILED_LANDING_PAGE');
            default:
                return `${t(translation,'UPLOADING_LANDING_FORM')}...`
        } 
    }else{
        switch (status) {
            case 'paused':
                
                return 'Paused';
            case 'failed':
                return 'Failed';
            case 'finish':
                return 'Success';
            case 'unsupported':
                    return 'Failed';
            default:
                return 'Uploading...'
        }
    }
    
}

class FileUploader extends React.Component{
    constructor(props){
        super(props)
    }
    render(){
        const{
            data_file,
            key,
            handleRemoveFile,
            handleReuploadFile,
            handleCancelUpload,
            translation,
        } = this.props
        const value = fromJS(data_file)
        const hide = value.get('showBarProgress')?'':'hide'
        const failed_icon = value.get('status') == 'failed' ? '' : 'hide' 
        const paused_icon = value.get('status') == 'paused' ? '' : 'hide' 
        const progress = value.get('progress') != ''? value.get('progress') : 0
        const progressFile = value.get('progressFile') ? value.get('progressFile') : 0
        const progressUnit = value.get('progressUnit')? value.get('progressUnit') : 0
        const sizeFile = value.get('sizeFile') ? value.get('sizeFile') : 0
        const sizeUnit = value.get('sizeUnit') ? value.get('sizeUnit') : 0
        const statusUpload = value.get('status')? value.get('status') : 'failed'

        return(
    		<div className="div-file" key={key}>
            	<div className="div-filename horizontal-item--between">
                    <div className="vertical-item--center">
                        <i className="icon icon-i-file-doc"></i>
                    </div>
                    <label className="m-l-15">{value.get('filename')}</label>
                    <div className="button-action-container">
                        <i data-toggle="tooltip" data-placement="top" title={`${t(translation,'RETRY_UPLOAD_LANDING_PAGE')}`} className={`icon icon-i-failed-doc m-r-5 ${failed_icon}`} onClick={handleReuploadFile}></i>
                        <i data-toggle="tooltip" data-placement="top" title={`${t(translation,'CONTINUE_UPLOAD_LANDING_PAGE')}`} className={`icon icon-i-retry-doc m-r-5 ${paused_icon}`} onClick={handleReuploadFile}></i>
                        {/* <i className={`icon icon-i-retry-doc m-r-15 failed`} onClick={handleCancelUpload}></i> */}
                        <i data-toggle="tooltip" data-placement="top" title={`${t(translation,'DELETE_LANDING_FORM')}`} className="icon icon-i-del-doc" onClick={handleRemoveFile}></i>
                    </div>
                </div>
                <ProgressBarMultiDoc className={hide} progressVal={progress} status={statusUpload}/>
                <div className={`div-status-size horizontal-item--between ${hide}`}>
                    <label>{renderStatus(value.get('status'),translation)} <strong>{progress}%</strong></label>
                    <span>{progressFile} {progressUnit} of {sizeFile} {sizeUnit}</span>
                    {/* <label>Uploading... <strong>40%</strong></label> */}
                    {/* <span>1,8 MB of 3,5 MB</span> */}
                    {/* <label>Paused</label> */}
                    
                    {/* <span>{progressFile} {progressUnit} of {sizeFile} {sizeUnit}</span> */}
                </div>
            </div>
        )
    }
}

export default FileUploader